import {
  EMAIL_VALIDATOR_V2,
  REQUIRED_VALIDATOR_V2,
  useForm,
  useFormField,
  v2_useMinLengthValidator,
} from '../modules/forms';
import { PHONE_NUMBER_VALIDATOR } from '../modules/phone';

export interface AccountSettingsFormData {
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly phoneNumber: string;
}

export interface AccountSettingsFormOptions {
  /**
   * Initial data to populate the form with.
   */
  readonly initialData?: AccountSettingsFormData;
}

export function useAccountSettingsForm(
  onSubmit: (data: AccountSettingsFormData) => void,
  options?: AccountSettingsFormOptions,
) {
  const { initialData } = options ?? {};

  const nameMinLengthValidator = v2_useMinLengthValidator(2);

  const firstName = useFormField({
    value: initialData?.firstName ?? '',
    required: true,
    validators: [REQUIRED_VALIDATOR_V2, nameMinLengthValidator],
  });

  const lastName = useFormField({
    value: initialData?.lastName ?? '',
    required: true,
    validators: [REQUIRED_VALIDATOR_V2, nameMinLengthValidator],
  });

  const email = useFormField({
    value: initialData?.email ?? '',
    required: true,
    validators: [REQUIRED_VALIDATOR_V2, EMAIL_VALIDATOR_V2],
  });

  const phoneNumber = useFormField({
    value: initialData?.phoneNumber ?? '',
    required: true,
    validators: [REQUIRED_VALIDATOR_V2, PHONE_NUMBER_VALIDATOR],
  });

  const form = useForm({
    fields: {
      firstName,
      lastName,
      email,
      phoneNumber,
    },
    onSubmit,
  });

  return form;
}
